<div class="cont-title-sec">
  <h1 class="title-sect color-blue-dark font-30 f-31">Resumen general</h1>
</div>
<div class="row reverse--row">
  <div class="col-xs-12 col-md-5">
    <div>
      <div class="header-card d-flex bottom-xs">
        <h2 class="color-gray header-card_title u-medium f-20 wr-100">Accesos rápidos</h2>
      </div>
      <div class="corner-one card--two row row--no-margin around-md">
        <a  appDebounceClick tabindex="0" id="Accesos Rapidos _PTEC-Menu Derecha AffiliateWorker" title="Afiliar trabajador" [routerLink]="'/'+afiliarTraba" class="o-group-elms text-center color-blue-light items-card">
          <span class="u-round d-block"><em class="material-icons" aria-hidden="true">person_add</em></span>
          <span>Afiliar trabajador</span>
        </a>
        <a  appDebounceClick tabindex="0" id="Accesos Rapidos _PTEC-Menu Derecha MassAffiliate" title="Afiliación masiva" [routerLink]="'/'+afiliarMas" class="o-group-elms text-center color-blue-light items-card">
          <span class="u-round d-block"><em class="material-icons" aria-hidden="true">group_add</em></span>
          <span>Afiliación masiva</span>
        </a>
        <a appDebounceClick tabindex="0" id="Accesos Rapidos _PTEC-Menu Derecha AffiliateDocument" title="Certificado afiliación" [routerLink]="'/'+certificados" [queryParams]="{id: 'trabajador'}" class="o-group-elms text-center color-blue-light items-card">
          <span class="u-round d-block"><em class="material-icons" aria-hidden="true">archive</em></span>
          <span>Certificado afiliación</span>
        </a>
        <a appDebounceClick tabindex="0" id="Accesos Rapidos _PTEC-Menu Derecha Worker" title="Trabajadores" [routerLink]="'/'+trabajadores" class="o-group-elms text-center color-blue-light items-card">
          <span class="u-round d-block"><em class="material-icons" aria-hidden="true">people</em></span>
          <span>Trabajadores</span>
        </a>
      </div>
    </div>

    <div class="row row--no-margin cont-cards" >
      <div class="card bg-white shadow-item">
        <div class="d-flex">
            <div class="item-img col-xs-12 col-sm-5">
              <div class="row">
                <img src="./assets/images/encuesta.png" alt="Encuesta colsubsidio" class="img-size img-round-border">
              </div>
            </div>
            <div class="d-flex item-text color-gray-light col-xs-12 col-sm-7 justify-content-center">
              <div class="header-card d-flex bottom-xs  header-card_title">
                <p class="f-16 t-align-center color-gray wr-100">¿Cómo fue tu experiencia en nuestro portal? <br><br></p>
                <a [href]="urlEncuesta"
                  target="_blank" 
                  id="Encuesta"
                  title="Encuesta de experiencia" 
                  tabindex="0"
                  aria-hidden="true"
                  class="f-14 t-align-center color-blue-dark text-encuesta">
                ¡Compártenos tu opinión!
                  <em aria-hidden="true" class="material-icons material-icons-position">keyboard_arrow_right</em>
                </a>
              </div>
            </div>
        </div>
      </div>
    </div>

    <!--ESTE CALENDARIO SE SUPRIME POR TEMA DE ACCESIBILIDAD Y SE ACORDO OCULTAR DE MOMENTO HASTA ENCONTRAR
    UNA SOLUCION-->
    <!--<div class="hide-down--md">
      <app-header-card>
        <span class="color-gray">Agenda transaccional</span>
      </app-header-card>

      <div class="row justify-content-center">
        <div class="col-xs-12 col-md-12">
          <div class="card card--three bg-white mg-btm-30">
            <ul class="list-data list-data--itemSeparado list-data--itemSeparado-vivienda list-data--itemSeparado-visible">
              <li class="border-none list-data_item list-data_item--separado d-flex middle-xs wow fadeInDown text-center">
                <div class="col-xs-12">
                  <p class="title-100 mg-btm-30 mg-top-20">
                    En esta seccion veras los eventos resaltados de color amarillo al darle click encontrara la descripcion del evento
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row row--no-margin">
        <app-calendar class="w-100"></app-calendar>
      </div>
    </div>-->
  </div>

  <div class="col-xs-12 col-md-7">
    <div class="content-scroll-left">
      <mat-accordion title="consulte aqui el estado de las solicitudes de sus trabajadores">
        <mat-expansion-panel >
          <mat-expansion-panel-header >
            <h2 class="color-gray header-card_title u-medium f-20 pd-0" id="Consulta Afiliaciones Empleados">
              Historial de solicitudes
            </h2>
          </mat-expansion-panel-header>
            <table aria-label="Tabla de histórico de afiliaciones" class="rwd-table" width="100%" height="100%" cellpadding="0" cellspacing="0" id="tableAffiliation">
              <thead class="thead">
                <th  scope = "col" class="text-gray-category color-gray">
                  tipo
                </th>
                <th  scope = "col" class="text-gray-category color-gray">
                  Código de proceso
                </th>
            
                <th  scope = "col" class="text-gray-category color-gray">
                  Fecha de proceso
                </th>
            
                <th  scope = "col" class="text-gray-category color-gray">
                  Estado en proceso
                </th>
            
                <th  scope = "col" class="text-gray-category color-gray">
                  Detalle
                </th>
              </thead>
            
              <div class="row mt-masive" *ngIf="loadingTop">
                <div class="col-md-12 text-center">
                  <div class="spinner-two spinner-two-blue"></div>
                </div>
              </div>
            
              <tbody>
            
                <tr *ngIf="solicitudes.length <= 0 && !loadingTop">
                  <td colspan="4" style="text-align: center;">
                    <span class="text-gray-category color-red">No hay procesos de afiliación recientes</span>
                  </td>
                </tr>
            
                <tr *ngFor="let solicitud of solicitudes; let i = index;">
                  <td data-th="tipo">
                    <div>
                      {{ solicitud.sigla }}
                    </div>
                  </td>

                  <td data-th="Código de proceso ">
                    <div class="texto-recortado" title="{{ solicitud.radicado }}">
                      {{ solicitud.radicado }}
                    </div>
                  </td>
            
                  <td data-th="Fecha de proceso">
                    <div>
                      {{solicitud.processDate | date:'dd/MM/yyyy'}}
                    </div>
                  </td>
            
                  <td data-th="Estado en proceso"
                      class="text-gray-category"
                      [ngClass]="{
                        'color-blue': solicitud.processStatusCode=== 1,
                        'color-red': solicitud.processStatusCode === 3,
                        'color-green':solicitud.processStatusCode === 2
                      }"
                  >
                    <div>
                      {{ obtenerNombreEstado(solicitud.processStatus) }}
                    </div>
                  </td>
            
                  <td data-th="Detalle" *ngIf="solicitud.processExcelMas == null" class="text-gray-category color-gray">
            
                    <button type="button" appDebounceClickGeneral tabindex="0"
                    data-category = "Inicio"
                    data-action = "Histórico de Afiliaciones"
                    data-label = "Consultar"
                    data-event = "ga_event_consultar"
                    *ngIf="!loadingDetail[i]" (click)="showElement(solicitud, i)"  class="icon-download-hover btn-not-outline detail btn-nav" >
                      <img  src="./assets/icons/icon-eye.svg"
                        alt="Visualizar archivo de afiliación con código de proceso {{solicitud.radicado}} fecha de proceso {{solicitud.processDate | date:'longDate'}} estado de proceso {{solicitud.processStatusCode | formatStatusProcess}}"/>
                    </button>
                    <div *ngIf="loadingDetail[i]" class="spinner-two spinner-two-blue"></div>
                  </td>
                </tr>
            
                <div class="h-35"></div>
              </tbody>
            </table>   
            <div class="content-btn-detail">
              <button type="button" appDebounceClickGeneral tabindex="0"
              data-category = "Inicio"
              data-action = "Histórico de Afiliaciones"
              data-label = "Ver más"
              data-event = "ga_event_vermas"
              class="bnt-datail btn-nav"
              (click)="openLink()">
                <span class="text-btn-datail">Consultar Históricos</span>
              </button>
            </div>       
        </mat-expansion-panel>
      </mat-accordion>

      <!--HTML BI-->
      <!--<app-aportes></app-aportes>-->
      <app-process-summary *ngIf="companyData?.numeroDocumento" [companyData] = "companyData" title="Consultas Masivas" [userloggedin] = "userloggedin"></app-process-summary>
      <!--<app-affiliates-process [titleSite]="'Histórico de Afiliaciones Empleado'" [userloggedin] = "userloggedin"></app-affiliates-process>
    -->
      <!--HTML BI-->
    </div>
  </div>

  <div class="col-xs-12 col-md-3"></div>
</div>
<app-modal *ngIf="infoImportant !== undefined && infoImportant !== null"
    [idModal]="idModal"
    [textDescription]="infoImportant.text">
</app-modal>
